import { Component, Input } from '@angular/core';
import { iconsLibrary } from "../../../../theme/constants";
import { Router } from '@angular/router';

@Component({
  selector: "cowing-back-button",
  templateUrl: "./cowing-back-button.component.html",
  styleUrls: ["./cowing-back-button.component.scss"],
})
export class CowingBackButtonComponent {
  @Input('previous') previous;
  constructor(private router: Router) {}

  onClickBack() {
    this.router.navigate([`coworker-${this.previous}`]);
  }
  public get getIcon() {
    return `${iconsLibrary["arrowLeftBlack"]}`;
  }
}
